<!-- @format -->

<template>
  <div class="row">
    <div class="twelve wide column">
      <div v-if="false" class="ui segment">
        <h3>Reports</h3>
        <div class="ui form">
          <div class="field">
            <label>Signature to be used in Reports</label>
            <sui-input v-model="signature" />
          </div>
        </div>
        <div class="ui segment">
          <div class="ui large green button" @click="saveSignature">
            Save Signature
          </div>
          |
          <div class="ui large grey button" @click="initialLoad">Cancel</div>
        </div>
        <div class="ui segment message" v-if="message != ''">{{ message }}</div>
      </div>
      <div class="ui segment">
        <h3>Change Password</h3>
        <div class="ui form">
          <div class="field">
            <label>New Password</label>
            <sui-input v-model="password" type="password" />
          </div>

          <div class="field">
            <label>Confirm Password</label>
            <sui-input v-model="password2" type="password" />
          </div>
          <div
            class="ui segment message red"
            v-if="password != password2 && password2 != ''"
          >
            Passwords do not match
          </div>
        </div>
        <div class="ui segment" v-if="password == password2 && password2 != ''">
          <div class="ui large green button" @click="savePassword">
            Change Password
          </div>
          |
          <div class="ui large grey button" @click="passwordReset">Cancel</div>
        </div>
        <div class="ui segment message" v-if="pwdMessage != ''">
          {{ pwdMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateUserPassword, getUserSignature, updateUser } from "@/gateway";

export default {
  name: "MyAccountTable",
  props: {
    msg: String,
  },
  data() {
    return {
      signature: "",
      message: "",
      password: "",
      password2: "",
      pwdMessage: "",
    };
  },
  methods: {
    async saveSignature() {
      const response = await updateUser({ signature: this.signature });

      this.message = response.message;
      this.initialLoad();
    },
    async passwordReset() {
      this.password = "";
      this.password2 = "";
    },
    async savePassword() {
      const response = await updateUserPassword({
        password: this.password,
        password2: this.password2,
      });
      this.pwdMessage = response.success
        ? "Successfully updated"
        : "Error: " + response.responseStatus.message;

      this.initialLoad();
    },

    async initialLoad() {
      const signatureResponse = await getUserSignature({});
      this.signature = signatureResponse.signature;

      //await this.getFees("Platform");
    },
  },
  async mounted() {
    this.initialLoad();
  },
};
</script>
